"use client";
import Filter from "@/app/components/Filter";
import BreadCrumb from "@/app/components/lib/breadcrumb/BreadCrumb";
import CategoryDetailsBlackBox from "@/app/components/pages-components/category-page/CategoryDetailsBlackBox";
import ViewCategoryPixel from "./ViewCategoryPixel";
import { useGetAllProductsQuery } from "@/api/AppApi/services/product";
import { useGetAllCategoriesQuery } from "@/api/AppApi/services/category";
import { useGetFiltersQuery } from "@/api/AppApi/services/filters";
import { IGetFiltersParams } from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import { useTranslation } from "@/hooks/localization/useTranslations";

export const queryFiltersParams = (query: any): IGetFiltersParams => ({
  ...(query?.q && { q: query.q }),
  ...(query?.category_id && { category_id: query.category_id }),
  ...(query?.brand_id && { brand_id: query.brand_id }),
  ...(query?.external_id && { external_id: query.external_id }),
});
const limit = 24;

const productQuery = (query: any) => {
  return {
    ...query,
    page: query.page ?? 1,
    limit: limit,
  };
};

type TProps = {
  searchParams: { [key: string]: string };
  loader: React.ReactElement;
};

const Categories: React.FC<TProps> = ({ searchParams, loader }) => {
  const t = useTranslation();
  const { data: productsData, isLoading: isProductLoading } =
    useGetAllProductsQuery({
      params: productQuery(searchParams),
    });

  const { data: allCategoriesData, isLoading: isCategoriesLoading } =
    useGetAllCategoriesQuery({
      enabled: true,
    });
  const { data: filtersData } = useGetFiltersQuery(
    queryFiltersParams(searchParams),
  );
  const subcategories = allCategoriesData?.result;
  const products = productsData?.result?.data;
  const filters = filtersData?.result;
  return (
    <>
      <Filter filters={filters ?? []} productNum={products?.length ?? 0} />

      <div className="category-page">
        {isProductLoading || isCategoriesLoading ? (
          loader
        ) : (
          <>
            <BreadCrumb
              // noHome
              hideCrumbBack
              hierarchy={[
                {
                  text: t.all_products,
                },
              ]}
            />
            <CategoryDetailsBlackBox
              subcategories={subcategories!}
              products={products!}
              pageCount={productsData?.result?.meta?.last_page || 1}
              searchParams={searchParams}
            />
          </>
        )}
      </div>
      <ViewCategoryPixel
        products={products ?? []}
        item_list_name={t.all_products}
        item_list_id={""}
      />
    </>
  );
};

export default Categories;
